import { styled } from "@mui/material/styles"

export const Dropzone = styled("div")(({ theme }) => ({
  minHeight: "170px",
  background: "rgb(244, 211, 185)",
  borderRadius: "5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "20px",
  padding: "15px 10px",
  cursor: "pointer",
  width: "100%",
  border: "2px dashed #F8974C",
  outline: "none",
  textAlign: "center",
  marginBottom: "15px",
  color: "rgb(107, 100, 95)",
  transition: "background 0.2s",
  "& p": {
    fontWeight: "bold",
  },
}))

export const DragActive = styled(Dropzone)({
  background: "rgba(167, 177, 235, 0.4)",
})

export const DragAccept = styled(Dropzone)({
  background: "rgb(244, 211, 185)",
})

export const DragReject = styled(Dropzone)({
  color: "rgba(255, 0, 0, 0.4)",
  border: "2px dashed rgba(255, 0, 0, 0.4)",
})

export const BtnUpload = styled("button")({
  width: "100%",
  backgroundColor: "#F8974C",
  color: "#fff",
  padding: "10px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#F8974C",
    boxShadow: "none",
  },
})

export const BtnDownload = styled("button")({
  width: "40%",
  backgroundColor: "#F8974C",
  color: "#fff",
  padding: "10px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#F8974C",
    boxShadow: "none",
  },
})

export const CloseBtn = styled("button")({
  background: "#f1f1f5",
  position: "absolute",
  top: 8,
  right: 8,
  width: 25,
  height: 25,
})

export const ProgressWrapper = styled("div")({
  margin: "25px 0 20px",
})

export const DatePickerWrapper = styled("div")({
  width: "100%",
  padding: "19.5px 14px",
  borderRadius: "4px",
  background: "transparent",
  border: "1px solid #c0c0c0",
  position: "relative",
  zIndex: 1,
  outline: "none",
  "&:hover": {
    border: "1px solid #000",
    cursor: "pointer",
  },
  "&:focus": {
    border: "1px solid #F8974C",
  },
})

export const CalendarIconWrapper = styled("div")({
  position: "absolute",
  top: "45%",
  right: "10%",
  transform: "translateY(-50%)",
})
